import { render, staticRenderFns } from "./ProgrammeSubjectGroup.vue?vue&type=template&id=6462c4dc&"
import script from "./ProgrammeSubjectGroup.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSubjectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports